import React from "react";
import Portfolio from "../../container/Portfolio/Portfolio";
import Product from "../../container/Product/Product";
import Cover from "../cover/Cover";
import Profile from "../profile/Profile";
import Welcome from "../welcome/Welcome";

const Content = (props) => {
    let page = "";
    if (props.page === 'welcome') {
        page = <Welcome />;
    }else if (props.page === 'profile') {
        page = <Profile />;
    }else if (props.page === 'portfolio') {
        page = <Portfolio />;
    }else if (props.page === 'product') {
        page = <Product />;
    }

    return (
        <main>
            <div className="container">
                <Cover />
                {page}
            </div>
        </main>
    )
}

export default Content;
